import customHttp from "./httpCustom";

export const changePreferredLanguage = data => {
	return customHttp.post('/api/auth/preferredLanguage', data);
};

